'use client';

import React from 'react';
import Link from 'next/link';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import { BlogPost } from '@/types/blog';

interface BlogPostNavigationProps {
  slug: string;
  allPosts: BlogPost[];
}

export default function BlogPostNavigation({
  slug,
  allPosts,
}: BlogPostNavigationProps) {
  const sorted = [...allPosts].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );
  const idx = sorted.findIndex((p) => p.slug === slug);
  const prevPost = sorted[idx - 1];
  const nextPost = sorted[idx + 1];

  return (
    <section className="grid grid-cols-2 gap-4 mt-16 pt-8 border-t border-gray-800/50">
      {/* Previous */}
      {prevPost ? (
        <Link
          href={`/blog/${prevPost.category}/${prevPost.slug}/`}
          className="group flex flex-col justify-between rounded-lg "
        >
          <span className="flex items-center gap-2 text-xs text-neutral-400">
            <FiArrowLeft className="size-3 md:size-4" /> Previous
          </span>
          <h3 className="mt-2 underline-custom nav-blog-post group-hover:text-white line-clamp-2">
            {prevPost.title}
          </h3>
        </Link>
      ) : (
        <div />
      )}

      {/* Next */}
      {nextPost ? (
        <Link
          href={`/blog/${nextPost.category}/${nextPost.slug}/`}
          className="group flex flex-col text-right justify-between rounded-lg "
        >
          <div className="flex items-center gap-2 text-xs  text-neutral-400  justify-end">
            Next <FiArrowRight className="size-3 md:size-4" />
          </div>
          <h3 className="mt-2 underline-custom nav-blog-post group-hover:text-white line-clamp-2">
            {nextPost.title}
          </h3>
        </Link>
      ) : (
        <div />
      )}
    </section>
  );
}
